/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Subscription_DescInputs */

const en_settings_subscription_desc = /** @type {(inputs: Settings_Subscription_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your plan and billing.`)
};

const de_settings_subscription_desc = /** @type {(inputs: Settings_Subscription_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte deinen Plan und die Abrechnung.`)
};

const fr_settings_subscription_desc = /** @type {(inputs: Settings_Subscription_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère ton plan et ta facturation.`)
};

const es_settings_subscription_desc = /** @type {(inputs: Settings_Subscription_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione su plan y facturación.`)
};

const it_settings_subscription_desc = /** @type {(inputs: Settings_Subscription_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci il tuo piano e la fatturazione.`)
};

const nl_settings_subscription_desc = /** @type {(inputs: Settings_Subscription_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer je plan en facturering.`)
};

const pl_settings_subscription_desc = /** @type {(inputs: Settings_Subscription_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj swoim planem i rozliczeniami.`)
};

const fi_settings_subscription_desc = /** @type {(inputs: Settings_Subscription_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallinnoi tilaustasi ja laskutusta.`)
};

const da_settings_subscription_desc = /** @type {(inputs: Settings_Subscription_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrer din plan og fakturering.`)
};

const sv_settings_subscription_desc = /** @type {(inputs: Settings_Subscription_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantera ditt plan och fakturering.`)
};

/**
* | output |
* | --- |
* | "Manage your plan and billing." |
*
* @param {Settings_Subscription_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_subscription_desc = /** @type {((inputs?: Settings_Subscription_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Subscription_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_subscription_desc(inputs)
	if (locale === "fr") return fr_settings_subscription_desc(inputs)
	if (locale === "es") return es_settings_subscription_desc(inputs)
	if (locale === "it") return it_settings_subscription_desc(inputs)
	if (locale === "nl") return nl_settings_subscription_desc(inputs)
	if (locale === "pl") return pl_settings_subscription_desc(inputs)
	if (locale === "fi") return fi_settings_subscription_desc(inputs)
	if (locale === "da") return da_settings_subscription_desc(inputs)
	if (locale === "sv") return sv_settings_subscription_desc(inputs)
	return en_settings_subscription_desc(inputs)
});